import React from "react";
import { reportError } from "./clientErrorReporter";
import { isClientErrorsEnabled } from "../helpers/clientErrorsEnabled";
import "./appErrorBoundary.scss";

type State = { crashed: boolean };

/**
 * Catches a crash anywhere below it and shows a calm card with Reload instead of a blank page. The crash
 * is reported automatically; nothing technical is shown to the user.
 */
export default class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { crashed: false };

  static getDerivedStateFromError(): State {
    return { crashed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    reportError("CRASH", error, info?.componentStack || undefined);
  }

  render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <main className="hkp-crash" role="alert">
        <div className="hkp-crash__card">
          <h1 className="hkp-crash__title">Something went wrong</h1>
          <p className="hkp-crash__text">
            This screen stopped working.{isClientErrorsEnabled() ? " We have been told about it." : ""} Reloading usually fixes it.
          </p>
          <div className="hkp-crash__actions">
            <button type="button" className="hkp-crash__btn hkp-crash__btn--primary" onClick={() => window.location.reload()}>
              Reload
            </button>
            <button type="button" className="hkp-crash__btn" onClick={() => window.location.assign("/")}>
              Go to home
            </button>
          </div>
        </div>
      </main>
    );
  }
}
